/**
 * document.title 用（Rails `config/locales/page_title.yml` の `page_title.roots` と同一文言にすること）
 */
export const PAGE_TITLE_SERVICE_NAME =
  '【公式】社内SE転職ナビ｜社内SE・情シス転職に特化した専門サービス';
